var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.12,
    height: 17.522,
    viewBox: "0 0 13.12 17.522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tap_copy",
    "data-name": "tap copy",
    transform: "translate(-57.703 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35878",
    "data-name": "Path 35878",
    d: "M58.847,5.169a4.024,4.024,0,1,1,7.891,1.113l1.1.317a5.169,5.169,0,1,0-8.829,2l.855-.76A4.016,4.016,0,0,1,58.847,5.169Z",
    fill: "#e4b6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35879",
    "data-name": "Path 35879",
    d: "M114.2,53.659a3.261,3.261,0,1,0-6.5-.4,3.226,3.226,0,0,0,.694,2.008l.9-.706a2.092,2.092,0,0,1-.45-1.3,2.117,2.117,0,1,1,4.217.259Z",
    transform: "translate(-48.093 -48.092)",
    fill: "#e4b6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35880",
    "data-name": "Path 35880",
    d: "M116.982,114.422a.973.973,0,0,0-.973.973h-.381v-1.048a.973.973,0,0,0-1.945,0V115.4H113.3v-2a.973.973,0,0,0-1.945,0v2h-.381v-4.422a.973.973,0,1,0-1.945,0v7.2h-.381v-2.348a.973.973,0,0,0-1.945,0V119.4a3.926,3.926,0,0,0,3.922,3.922h3.408a3.926,3.926,0,0,0,3.922-3.922V115.4A.973.973,0,0,0,116.982,114.422Z",
    transform: "translate(-47.131 -105.804)",
    fill: "#e4b6ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManual);
export default __webpack_public_path__ + "static/media/manual.f9f6d7b7034660124553ec8b58d5b6fa.svg";
export { ForwardRef as ReactComponent };